import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const ShareIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 74 80" {...props}>
      <path
        fill={fill}
        d="M59.6001606,51.3664779 C55.8754939,51.3664779 52.4916758,52.7956067 49.9319485,55.1120885 L28.4697061,42.6746547 C28.6715242,41.7259897 28.7993424,40.7505702 28.7993424,39.7428226 C28.7993424,38.9847824 28.7141303,38.2479227 28.596403,37.5222106 L49.7267667,24.7102157 C52.307797,27.1348297 55.7768273,28.633074 59.6001606,28.633074 C67.5405848,28.633074 73.9998879,22.2120272 73.9998879,14.317261 C73.9998879,6.42249486 67.5405848,0.000333333333 59.6001606,0.000333333333 C51.6597364,0.000333333333 45.2004333,6.42249486 45.2004333,14.317261 C45.2004333,15.5958966 45.3787061,16.832171 45.7016152,18.0115925 L25.2630394,30.4033209 C22.6214636,27.3689304 18.7443121,25.4258949 14.4007364,25.4258949 C6.45919091,25.4258949 -0.000112121212,31.8480564 -0.000112121212,39.7428226 C-0.000112121212,47.6375888 6.45919091,54.0597503 14.4007364,54.0597503 C18.5010091,54.0597503 22.189797,52.3329792 24.8134333,49.5873129 L45.7722515,61.7326782 C45.4044939,62.9879037 45.2004333,64.3111298 45.2004333,65.6834056 C45.2004333,73.577057 51.6597364,80.0003333 59.6001606,80.0003333 C67.5405848,80.0003333 73.9998879,73.577057 73.9998879,65.6834056 C73.9998879,57.7886394 67.5405848,51.3664779 59.6001606,51.3664779"
      />
    </Icon>
  );
};

ShareIcon.propTypes = {
  fill: PropTypes.string,
};

export default ShareIcon;
